export class DeltaError extends Error {}
